export { default } from "app/pages/LabellingJobs/LabellingJobDetail/LabellingJobFilter/LabellingJobFilter";
